/*
  Open every collapsed section before the page prints, and put it back afterwards.

  The product description is an accordion because 3,700 characters of copy does not belong
  open on a 415px screen. On paper the opposite is true: the sheet is being attached to a
  requisition, and a section that prints as a heading with nothing under it is worse than
  no sheet at all.

  atlas-print.css already overrides the user-agent rule that hides a closed details, which
  is enough in Chrome. Safari ignores that override, so the attribute is set as well, and
  only on the elements that were shut, so afterprint restores exactly what the reader had.
*/
(() => {
  let opened = [];

  const openAll = () => {
    opened = Array.from(document.querySelectorAll('details:not([open])'));
    opened.forEach((d) => d.setAttribute('open', ''));
  };

  const restore = () => {
    opened.forEach((d) => d.removeAttribute('open'));
    opened = [];
  };

  window.addEventListener('beforeprint', openAll);
  window.addEventListener('afterprint', restore);

  // Safari fires neither event; it drives the same thing through a media query listener.
  const query = window.matchMedia('print');
  if (query.addEventListener) {
    query.addEventListener('change', (event) => (event.matches ? openAll() : restore()));
  }
})();
